import React from 'react';
import MemoryMapFlow from './MemoryMapFlow';

const sections = [
  {
    title: 'Definite Sum Calculation',
    descriptionPoints: [
      { text: 'Basic Sums', subpoints: [] },
      { text: 'Change of Index', subpoints: [] },
    ],
    link: '/advanced/series/definite_sum_calculation',
  },
  {
    title: 'Double Sum',
    descriptionPoints: [
      { text: 'Calculate Sum by Sum', subpoints: [] },
      { text: 'Reverse the Two Sums', subpoints: [] },
      { text: 'Triple Sum Calculation', subpoints: [] },
    ],
    link: '/advanced/series/double_sum',
  },
  {
    title: 'Series',
    descriptionPoints: [
      {
        text: 'Convergence Study by using:',
        subpoints: [
          'Criterions',
          'Comparision',
          'Taylor expansion',
          'Inequalities',
          'Comparison Integral-Series',
        ],
      },
      {
        text: 'Sum Calculation',
        subpoints: ['Power Series expansion', 'Telescoping'],
      },
    ],
    link: '/advanced/series/series',
  },
  {
    title: 'Series of Functions',
    descriptionPoints: [
      {
        text: 'Convergence Types:',
        subpoints: ['Simple', 'Absolute', 'Uniform', 'Normal'],
      },
      {
        text: 'Interchange of Sum with:',
        subpoints: ['Integral', 'Derivative'],
      },
      {
        text: 'Integral Calculation',
        subpoints: [
          'Power Series expansion',
          'Telescoping',
          'Calculate derivative first',
          'Calculate primitve first',
          'Use differential equation',
        ],
      },
    ],
    link: '/advanced/series/series_of_functions',
  },
];

const SeriesMemoryMap = () => (
  <MemoryMapFlow title="Series" sections={sections} />
);

export default SeriesMemoryMap;
